import React, { useState } from "react";
import { CheckCircle2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { HEAD, mask } from "@/components/PdPill";

const OPTIONS = [
  ["new_dac", "New DAC diya", "Naya 4–8 digit DAC likho"],
  ["delivered", "Delivered from our side", "Agency ne deliver kar diya"],
  ["note", "Remark", "Jaise: Portal pe fix kar diya"],
];
const inputCls = "w-full h-11 px-3 text-sm border border-[#E0DFD6] rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-[#385C4B]/30";

export function ResolveDialog({ row, hide, onClose, onDone }) {
  const [action, setAction] = useState("new_dac");
  const [dac, setDac] = useState("");
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);
  const valid = action === "delivered" || (action === "new_dac" ? /^\d{4,8}$/.test(dac) : note.trim().length >= 3);

  const submit = async () => {
    setSaving(true);
    try {
      await api.post(`/groups/${row.group_id}/messages/${row.message_id}/lpg/${row.entry_index}/resolve`, {
        action, new_dac: action === "new_dac" ? dac : undefined, note: action === "note" ? note.trim() : undefined,
      });
      toast.success("Complaint resolved ✓ · agency chat + delivery man ko update bhej diya");
      await onDone();
      onClose();
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="pd-resolve-dialog">
        <DialogHeader>
          <DialogTitle className={`${HEAD} text-xl`}>Complaint resolve karo</DialogTitle>
          <DialogDescription className="font-mono text-xs" data-testid="pd-resolve-target">
            {row.agency} · LPG {mask(row.lpg_id, hide)} · DAC {row.dac_code || "—"} · DAC ✗ by {row.marked_by}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2" role="radiogroup">
          {OPTIONS.map(([k, label, sub]) => (
            <button key={k} type="button" role="radio" aria-checked={action === k} onClick={() => setAction(k)} data-testid={`pd-resolve-choice-${k}`}
              className={`w-full text-left rounded-xl border px-4 py-3 transition-colors ${action === k ? "border-[#385C4B] bg-[#385C4B]/5" : "border-[#E0DFD6] bg-white hover:bg-[#FAFAF6]"}`}>
              <div className="flex items-center gap-2.5">
                <span className={`w-4 h-4 rounded-full border-2 grid place-items-center ${action === k ? "border-[#385C4B]" : "border-[#C0C0B8]"}`}>
                  {action === k && <span className="w-2 h-2 rounded-full bg-[#385C4B]" />}
                </span>
                <span className="text-sm font-semibold text-[#1A1A1A]">{label}</span>
              </div>
              <div className="text-xs text-[#6B6B61] ml-[26px] mt-0.5">{sub}</div>
            </button>
          ))}
        </div>
        {action === "new_dac" && (
          <input value={dac} onChange={(e) => setDac(e.target.value.replace(/\D/g, "").slice(0, 8))} inputMode="numeric" placeholder="New DAC (4–8 digit)"
            className={`${inputCls} font-mono`} data-testid="pd-resolve-new-dac" autoFocus />
        )}
        {action === "note" && (
          <textarea value={note} onChange={(e) => setNote(e.target.value.slice(0, 300))} rows={3} placeholder="Remark likho…"
            className={`${inputCls} h-auto py-2.5 resize-none`} data-testid="pd-resolve-note" autoFocus />
        )}
        <div className="grid grid-cols-2 gap-2 pt-1">
          <button onClick={onClose} className="h-11 rounded-lg border border-[#E0DFD6] bg-white text-sm font-semibold hover:bg-[#F4F3EC] transition-colors" data-testid="pd-resolve-cancel">Cancel</button>
          <button onClick={submit} disabled={!valid || saving} data-testid="pd-resolve-submit"
            className="h-11 rounded-lg bg-[#385C4B] text-white text-sm font-semibold inline-flex items-center justify-center gap-1.5 disabled:opacity-50 hover:bg-[#2D4A3C] transition-colors">
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <CheckCircle2 className="w-4 h-4" />}Resolve
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
